export const OptioPayRoutes = {
    ROOT: "/optiopay",
    DEACTIVATION: "/optiopay/deactivation",
    ACTIVATION: "/optiopay/activation",
    FAQ: "/optiopay/:id/faq",
    CODE: "/optiopay/:id/code",
    SUCCESS: "/optiopay/success",
    SIGNING: "/optiopay/signing",
    PDF: "/optiopay/:id/pdf/:webUrl"
};



// WEBPACK FOOTER //
// ./src/components/optiopay/OptioPayRoutes.ts